import React, { useEffect, useState, Fragment } from 'react';
import { Clock } from 'lucide-react';
function getInitialTarget(): number {
  if (typeof window === 'undefined') return Date.now() + 60 * 60 * 1000;
  const stored = window.localStorage.getItem('triatlon_offer_deadline');
  if (stored) {
    const t = parseInt(stored, 10);
    if (!isNaN(t) && t > Date.now()) return t;
  }
  // 1 hour offer window
  const target = Date.now() + 60 * 60 * 1000;
  window.localStorage.setItem('triatlon_offer_deadline', String(target));
  return target;
}
function format(n: number) {
  return String(Math.max(0, n)).padStart(2, '0');
}
interface CountdownTimerProps {
  variant?: 'light' | 'dark';
}
export function CountdownTimer({
  variant = 'light'
}: CountdownTimerProps) {
  const [target] = useState<number>(() => getInitialTarget());
  const [now, setNow] = useState<number>(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = Math.max(0, target - now);
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff / (1000 * 60) % 60);
  const seconds = Math.floor(diff / 1000 % 60);
  const isDark = variant === 'dark';
  const blockBase = isDark ? 'bg-white/10 text-white border border-white/10' : 'bg-brand-dark text-white';
  const labelColor = isDark ? 'text-white/60' : 'text-slate-500';
  return <div className="w-full" data-id="element-153">
      <div className={`flex items-center justify-center gap-2 mb-3 text-xs font-bold uppercase tracking-widest ${isDark ? 'text-brand-green' : 'text-brand-dark'}`} data-id="element-154">
        <Clock size={14} data-id="element-155" />
        La oferta termina en
      </div>
      <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-156">
        {[{
        value: hours,
        label: 'Horas'
      }, {
        value: minutes,
        label: 'Min'
      }, {
        value: seconds,
        label: 'Seg'
      }].map((unit, i) => <Fragment key={unit.label} data-id="element-157">
            <div className="flex flex-col items-center" data-id="element-158">
              <div className={`${blockBase} font-serif font-bold text-3xl sm:text-4xl rounded-xl w-16 sm:w-20 h-16 sm:h-20 flex items-center justify-center tabular-nums`} data-id="element-159">
                {format(unit.value)}
              </div>
              <span className={`mt-1.5 text-[10px] sm:text-xs font-bold tracking-widest uppercase ${labelColor}`} data-id="element-160">
                {unit.label}
              </span>
            </div>
            {i < 2 && <span className={`font-serif text-3xl sm:text-4xl font-bold ${isDark ? 'text-white/30' : 'text-slate-300'}`} data-id="element-161">
                :
              </span>}
          </Fragment>)}
      </div>
    </div>;
}